'use client';

import { c as _c } from "react/compiler-runtime";
import { createWorkerClient } from '../../../../lib/entry.browser.js';
import { useQuery } from '../../../../tanstack/entry.js';
import { totalNumberOfRowsOptions } from '../../../queryOptions/entry.js';
import { useEngine } from '../../engine/entry.js';
import { defaultWorker } from '../defaultWorker.js';
let workerApi = defaultWorker;
function handleBeforeUnload() {
  workerApi.terminate();
}
if (typeof window !== 'undefined') {
  // ----- IF MORE THREADS IS DESIRED -----
  // The creation of the worker can be moved inside the react hook inside a useMemo and teared down in an empty useEffect.
  // However, instantiating the worker in the hook will create a new worker thread upon every unique hook call,
  // ie. if two components calls the hook there will be two workers.
  workerApi = createWorkerClient(
  // Worker and URL must always coexist, see:
  // https://github.com/vercel/next.js/issues/31009
  new Worker(new URL('../bestBetRowsWorker.js', import.meta.url), {
    type: 'module'
  }));
  window.addEventListener('beforeunload', handleBeforeUnload);
}
/**
 * Hook that calculates total number of rows in wager.
 *
 * @param wagerId Wager Id to calculate total number of rows for.
 * @returns Total number of rows for wager
 */
export function useTotalNumberOfRows(wagerId) {
  const $ = _c(3);
  const definition = useEngine();
  let t0;
  if ($[0] !== definition || $[1] !== wagerId) {
    t0 = totalNumberOfRowsOptions({
      wagerId
    }, {
      post: workerApi.post,
      definition
    });
    $[0] = definition;
    $[1] = wagerId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useQuery(t0);
}